import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { VisualVO } from "./VisualVO";

export class AvatarVO extends VisualVO {
    public xp: number = NaN;
    public userId: number = 0;
    public playerId: number = 0;
    public gender: string = "";
    public avatarWear: Map<any, any>;
    public displayName: string = "";
    public allowGiveChips: boolean = true;

    public cashTotal: number = NaN;
    public goldTotal: number = NaN;

    constructor() {
        super();
    }
}
classImplementsInterfaces(AvatarVO, "IInventoryVO");
